import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1d07a22"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "ID Verification Overview", -1))
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-10" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex justify-content-end mb-10"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator my-10" }, null, -1))
const _hoisted_11 = { class: "d-flex flex-stack mb-10" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fs-7 fw-bold me-2 d-block lh-1 pb-1" }, "Key"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-800 fs-1 fw-bold" }, "Metrics")
], -1))
const _hoisted_13 = {
  key: 0,
  class: "d-flex gap-4"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 1,
  class: "d-flex align-items-center me-2"
}
const _hoisted_17 = {
  key: 0,
  class: "badge badge-danger ms-2"
}
const _hoisted_18 = {
  key: 3,
  class: "d-flex flex-column mb-10"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fs-7 fw-bold me-2 d-block lh-1 pb-1" }, "AML"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-800 fs-1 fw-bold" }, "Results")
], -1))
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "text-center"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator my-10" }, null, -1))
const _hoisted_23 = { class: "d-flex flex-stack mb-10" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fs-7 fw-bold me-2 d-block lh-1 pb-1" }, "Raw"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-800 fs-1 fw-bold" }, "Results")
], -1))
const _hoisted_25 = { class: "d-flex gap-4" }
const _hoisted_26 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_27 = /*#__PURE__*/_createTextVNode("  \n                ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("\n            ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_SummaryCard = _resolveComponent("SummaryCard")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.$modals.VIEW_VERIFICATION_MODAL,
    ref: "viewVerificationModalRef",
    class: "modal fade",
    tabindex: "-1",
    "aria-hidden": "true",
    backdrop: "static",
    keyboard: "false"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "btn btn-icon btn-sm btn-active-icon-primary",
            id: `${_ctx.$modals.VIEW_VERIFICATION_MODAL}_close`,
            "data-bs-dismiss": "modal"
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ], 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", null, [
                  (_ctx.idImageBack)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("button", {
                          class: "float-right btn btn-sm btn-light-primary",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleView && _ctx.toggleView(...args)))
                        }, " View " + _toDisplayString(_ctx.currentView === _ctx.ImageView.FRONT ? "Back" : "Front"), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.activeSrc)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "d-flex flex-column flex-column-fluid bgi-position-center position-x-center bgi-no-repeat bgi-size-contain h-350px",
                        style: _normalizeStyle({
                  backgroundImage: `url(${_ctx.activeSrc})`,
                })
                      }, null, 4))
                    : _createCommentVNode("", true),
                  _hoisted_10
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-light-success",
                          disabled: _ctx.settingStatus,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setStatus(_ctx.IDVerificationStatus.VALID)))
                        }, " Approve ", 8, _hoisted_14),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-light-danger",
                          disabled: _ctx.settingStatus,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setStatus(_ctx.IDVerificationStatus.INVALID)))
                        }, " Decline ", 8, _hoisted_15)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.verification?.status !== _ctx.IDVerificationStatus.PENDING)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", {
                    'badge-success':
                      _ctx.verification?.status === _ctx.IDVerificationStatus.VALID,
                    'badge-danger':
                      _ctx.verification?.status === _ctx.IDVerificationStatus.INVALID,
                  }])
                        }, _toDisplayString(_ctx.verification?.status_display), 3),
                        (_ctx.hasExpired)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Expired"))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (!!_ctx.verification?.card_type)
                  ? (_openBlock(), _createBlock(_component_SummaryCard, {
                      key: 0,
                      title: "Card Type",
                      subtitle: "Card Type",
                      "right-text": 
                _ctx.verification?.card_type_display || _ctx.verification?.id_type_display
              ,
                      icon: "/media/icons/duotune/general/gen024.svg",
                      variant: "bg-light-info",
                      color: "info"
                    }, null, 8, ["right-text"]))
                  : _createCommentVNode("", true),
                (_ctx.meta.mrz_type)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_SummaryCard, {
                        title: "Validity Score",
                        subtitle: "Overall score informing validity of card",
                        "right-text": `${_ctx.meta.valid_score || 0}%`,
                        icon: "/media/icons/duotune/finance/fin006.svg",
                        variant: "bg-light-warning",
                        color: "warning"
                      }, null, 8, ["right-text"]),
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createBlock(_component_SummaryCard, {
                            key: 0,
                            title: "MRZ Type",
                            subtitle: "MRZ Type",
                            "right-text": _ctx.meta.mrz_type,
                            icon: "/media/icons/duotune/general/gen024.svg",
                            variant: "bg-light-info",
                            color: "info"
                          }, null, 8, ["right-text"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_SummaryCard, {
                        title: "Valid Number",
                        subtitle: "If the card number is valid or not",
                        "right-text": _ctx.meta.valid_number ? 'Yes' : 'No',
                        icon: "/media/icons/duotune/electronics/elc001.svg",
                        variant: "bg-light-danger",
                        color: "danger"
                      }, null, 8, ["right-text"]),
                      _createVNode(_component_SummaryCard, {
                        title: "Valid D.O.B",
                        subtitle: "If the date of birth is valid or not",
                        "right-text": _ctx.meta.valid_date_of_birth ? 'Yes' : 'No',
                        icon: "/media/icons/duotune/electronics/elc001.svg",
                        variant: "bg-light-success",
                        color: "success"
                      }, null, 8, ["right-text"]),
                      _createVNode(_component_SummaryCard, {
                        title: "Valid Expiration Date",
                        subtitle: "If the expiry date is valid or not",
                        "right-text": _ctx.meta.valid_expiration_date ? 'Yes' : 'No',
                        icon: "/media/icons/duotune/electronics/elc001.svg",
                        variant: "bg-light-primary",
                        color: "primary"
                      }, null, 8, ["right-text"])
                    ], 64))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.gviveMeta, (value, key) => {
                      return (_openBlock(), _createBlock(_component_SummaryCard, {
                        key: key,
                        title: key,
                        "right-text": value?.value,
                        subtitle: value?.info,
                        icon: 
                  value.icon ?? '/media/icons/duotune/electronics/elc001.svg'
                ,
                        variant: value.variant ?? 'bg-light-primary',
                        color: value.color ?? 'primary'
                      }, null, 8, ["title", "right-text", "subtitle", "icon", "variant", "color"]))
                    }), 128)),
                (_ctx.verification?.aml)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _hoisted_19,
                      (_ctx.verification?.aml?.status === _ctx.AMLVerificationStatus.FOUND)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createVNode(_component_SummaryCard, {
                              title: "Title",
                              "right-text": _ctx.matchedAml?.title,
                              subtitle: "Title as matched from AML records",
                              icon: "/media/icons/duotune/electronics/elc001.svg",
                              variant: "bg-primary-info",
                              color: "primary"
                            }, null, 8, ["right-text"]),
                            _createVNode(_component_SummaryCard, {
                              title: "First Name",
                              "right-text": _ctx.matchedAml?.first_name,
                              subtitle: "First name as matched from AML records",
                              icon: "/media/icons/duotune/electronics/elc001.svg",
                              variant: "bg-light-primary",
                              color: "primary"
                            }, null, 8, ["right-text"]),
                            _createVNode(_component_SummaryCard, {
                              title: "Last Name",
                              "right-text": _ctx.matchedAml?.last_name,
                              subtitle: "Last name as matched from AML records",
                              icon: "/media/icons/duotune/electronics/elc001.svg",
                              variant: "bg-light-info",
                              color: "info"
                            }, null, 8, ["right-text"]),
                            _createVNode(_component_SummaryCard, {
                              title: "Address",
                              "right-text": _ctx.matchedAml?.address,
                              subtitle: "Address as matched from AML records",
                              icon: "/media/icons/duotune/electronics/elc001.svg",
                              variant: "bg-warning-info",
                              color: "warning"
                            }, null, 8, ["right-text"]),
                            _createVNode(_component_SummaryCard, {
                              title: "Country",
                              "right-text": _ctx.matchedAml?.country,
                              subtitle: "Country as matched from AML records",
                              icon: "/media/icons/duotune/electronics/elc001.svg",
                              variant: "bg-danger-info",
                              color: "danger"
                            }, null, 8, ["right-text"]),
                            _createVNode(_component_SummaryCard, {
                              title: "Date of birth",
                              "right-text": _ctx.matchedAml?.date_of_birth || '-',
                              subtitle: "Date of birth as matched from AML records",
                              icon: "/media/icons/duotune/electronics/elc001.svg",
                              variant: "bg-info-info",
                              color: "info"
                            }, null, 8, ["right-text"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_21, "AML records not found"))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.verification?.meta && _ctx.isAdmin)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _hoisted_22,
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-light-primary",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showRaw = !_ctx.showRaw))
                          }, _toDisplayString(_ctx.showRaw ? "Hide" : "Show"), 1)
                        ])
                      ]),
                      (_ctx.showRaw)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("pre", null, [
                              _hoisted_27,
                              _createElementVNode("code", null, "\n                  " + _toDisplayString(_ctx.meta) + "\n                ", 1),
                              _hoisted_28
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger w-100 mt-4",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                }, " Close ")
              ], 64))
        ])
      ])
    ])
  ], 8, _hoisted_1))
}